import { render, staticRenderFns } from "./reporteriaInstitucion.vue?vue&type=template&id=45ac38db"
import script from "./reporteriaInstitucion.vue?vue&type=script&lang=js"
export * from "./reporteriaInstitucion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports